<template>
    <div>

      <!-- table -->
      <a-card title="">
          <div class="table-page-search-wrapper">
        <a-form  layout="inline" :form="form">
          <a-row :gutter="48"></a-row>

           <a-col :md="6" :sm="24" >
             <a-form-item label="客户编码">
              <a-input v-model="code1"  placeholder="" v-bind:disabled="yylimit" @blur="changecodes"
              v-decorator="['code1', { initialValue: code1, rules: [{ required: true, message: '请输入客户编码'}]}]"
              />
            </a-form-item>
          </a-col>

           <a-col :md="6" :sm="24" >
             <a-form-item label="客戶ID" style="margin-left: 10px">
              <a-input v-model="codeId1" v-bind:disabled="true" placeholder=""  />
            </a-form-item>
          </a-col>
                  <a-col :md="6" :sm="24" >
                    <a-form-item label="客户" style="margin-left: 10px">
                     <a-input v-model="name" v-bind:disabled="true" placeholder=""  />
                    </a-form-item>
                  </a-col>

                    <a-col :md="6" :sm="24" >
                    <a-form-item label="客户余额" style="margin-left: 10px">
                     <a-input v-model="remainAmount" v-bind:disabled="true" placeholder=""  />
                    </a-form-item>
                  </a-col>

                    <a-col :md="6" :sm="24" >
                    <a-form-item label="客户等级">
                     <a-input v-model="level" v-bind:disabled="true" placeholder=""  />
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="24">
                      <a-form-item label="物料名称" style="margin-left: 10px">
                          <a-select
                          v-model="selectMater"
                          showSearch
                          labelInValue
                          @change="changeMateriel"
                          :filterOption="filterOption"
                          placeholder="请选择"

                          >
                          <a-select-option v-for="(item, index) in materList" :key="index" :value="item.id">{{item.name}}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="24" >
            <a-form-item label="规格" style="margin-left: 10px">
               <a-input v-model="materielSpec" v-bind:disabled="true" placeholder=""  />
            </a-form-item>
          </a-col>


           <a-col :md="6" :sm="24" >
            <a-form-item label="单价" style="margin-left: 10px">
               <a-input v-model="mprice" v-bind:disabled="true" placeholder=""  />
            </a-form-item>
          </a-col>

           <a-col :md="6" :sm="24"  v-show="false">
            <a-form-item label="剩余量(吨)" >
             <a-input v-model="lessquailty" v-bind:disabled="true" placeholder=""/>
            </a-form-item>
          </a-col>


           <a-col :md="6" :sm="24" >
            <a-form-item label="车号">
              <a-auto-complete
                v-model="vehicleNo"
                :dataSource="vehicleNoList"
                placeholder=""
                :filterOption="filterOption"
                @change="(value) => changeVehicleNo(value)"
              />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24" >
            <a-form-item label="司机" style="margin-left: 10px">
                 <a-input v-model="driverName" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="手机号" style="margin-left: 10px">
                 <a-input v-model="phone" placeholder=""/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="车型" style="margin-left: 10px">
              <a-select
                v-model="vehicleTypeId"
                showSearch
                labelInValue
                @change="changeCarType"
                :filterOption="filterOption"
                placeholder="请选择"
              >
                <a-select-option v-for="(item, index) in corpVehicleTypeSelect" :key="index" :value="item.id">{{item.name}}</a-select-option>
              </a-select>


            </a-form-item>
          </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="身份证号">
                  <a-input
                  v-model="idcard"
                  placeholder=""
                 />
              </a-form-item>
            </a-col>

         <a-col :md="6" :sm="24" >
            <a-form-item label="荷载重量" style="margin-left: 10px">
              <a-input v-model="maxweight" v-bind:disabled="true" placeholder=""/>
            </a-form-item>
          </a-col>

           <a-col :md="6" :sm="24" >
            <a-form-item label="预约量" style="margin-left: 10px">
              <a-input v-model.trim="quailty"   placeholder="" @change="changeQuailty"
              v-decorator="['quailty', { initialValue: quailty, rules: [{ required: true, message: '请输入预约量'}]}]"

              />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24" >
            <a-form-item label="货物总金额" style="margin-left: 10px">
              <a-input v-model="mprice2" v-bind:disabled="true" placeholder=""/>
            </a-form-item>
          </a-col>



          <a-col :md="6" :sm="24" >
              <a-form-item label="上门日期">
                <a-date-picker
                  :disabledDate="disabledDate"
                  :defaultValue="defaultDate"
                  v-model="appointedDate"
                  placeholder="请选择日期" />
              </a-form-item>
            </a-col>



           <!-- <a-col>
                <a-form-item label="运输单位">
                  <a-select
                    v-model="corpLogisticsId"
                    showSearch
                    :filterOption="filterOption"
                    placeholder="请选择"
                    default-value="">
                    <a-select-option value=''>请选择</a-select-option>
                    <a-select-option v-for="(item, index) in logisticsSelect" :key="index" :value="item.id">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>  -->
          </a-row>
        </a-form>
        </div>


      </a-card>


      <a-card :bordered="false" >
        <a-button type="primary" @click="doSubmit" :loading="loading" style="float: right">提交</a-button>

      </a-card>

    </div>
  </template>

  <script>
import FooterToolBar from '@/components/FooterToolbar'
import { mixin, mixinDevice } from '@/utils/mixin'
import { vehicleSamplingFindByVehicleNo, getCorpSupplierList, corpBusinessList, corpLogisticsList, selectBusinessByCode, materielPriceselectBycodelevel, findscanquery, findcarnoinfo, vehicleTypeList, selectCodeByCustomer, findCarTypeById, findcartypeinfo } from '@/api/basic'
import { reservationAdd, baseInfoList, reservationAddMulti, queryOrder, deleteReservation } from '@/api/logistics'
import store from '@/store'
import Bus from '@/layouts/bus'
import moment from 'moment'
import { formatDate } from '@/utils/date.js'
import { noSpace } from '@/utils/util.js'
import { showMsg } from '@/utils/util'
import { findPrivileBycode, findproperties } from '@/api/sys'

export default {
  name: 'AdvancedForm',
  mixins: [mixin, mixinDevice],
  components: {
    FooterToolBar,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      materielList: [],
      driverList: [],
      vehicleList: [],
      vehicleNoList: [],
      driverNameList: [],
      phoneList: [],
      idcardMap: {},   // 身份证联动
      level: null,
      maxweight: null,
      maxAppoint: null,
      materielSpec: null,
      mprice: null,
      mprice2: null,
      selectMaterielId: null,
      selectMaterielName: null,
      corpVehicleTypeSelect: null,
      rolelimit: false,
      vehicleNo: '',
      driverName: '',
      phone: '',
      idcard: '',
      appointedDate: moment(new Date(), 'YYYY-MM-DD'),
      defaultDate: moment(new Date(), 'YYYY-MM-DD'),
      customercode: null,
      ylminmoney: 0.0, //预留最小金额

      loading: false,
      memberLoading: false,
      disabled: true,
      yylimit: true,
      bizList: this.$store.getters.bizList,
      bizCodeList: this.$store.getters.bizCodeList,
      selectedBizId: null,
      code1: null,
      codeId1: null,
      lessquailty: null,
      quailty: null,
      preBizId: null,
      materielData: {},
      materList: [],
      selectMater: { key: '', label: '请选择' },
      vehicleTypeId: { key: '', label: '' },
      supplierSelect: null,
      businessSelect: null,
      logisticsSelect: null,
      roleId: null,
      corpSupplierId: '',
      corpBusinessId: '',
      name: '',
      level: '',
      remainAmount: '',
      corpLogisticsId: '',

      hasOrder: '0',      // 有无订单预约
      continuity: true,    // 是否连续预约

      // table
      columns: [],
      allColumns: [
        {
          title: '物料名称',
          // slots: { title: 'title_materielName'},
          dataIndex: 'materielName',
          key: 'materielName',
          width: '150px',
          scopedSlots: { customRender: 'materielName' }
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          key: 'orderNo',
          width: '100px',
          scopedSlots: { customRender: 'orderNo' }
        },
        {
          title: '剩余量(吨)',
          dataIndex: 'residueQuantity',
          key: 'residueQuantity',
          width: '100px',
          scopedSlots: { customRender: 'residueQuantity' }
        },
        {
          slots: { title: 'title_predictQuantity' },
          dataIndex: 'predictQuantity',
          key: 'predictQuantity',
          width: '150px',
          scopedSlots: { customRender: 'predictQuantity' }
        },
        /*    {
             title: '订单信息',
             children: [{
               title: '订单号',
               dataIndex: 'orderNo',
               key: 'orderNo',
               width: '100px',
               scopedSlots: { customRender: 'orderNo' }
             },{
               title: '剩余量',
               dataIndex: 'residueQuantity',
               key: 'residueQuantity',
               width: '100px',
               scopedSlots: { customRender: 'residueQuantity' }
             },{
               // title: '预约量',
               slots: { title: 'title_predictQuantity'},
               dataIndex: 'predictQuantity',
               key: 'predictQuantity',
               width: '150px',
               scopedSlots: { customRender: 'predictQuantity' }
             }],
           },*/
        /*    {
             slots: { title: 'title_orderNo'},
             dataIndex: 'orderNo',
             key: 'orderNo',
             width: '120px',
             scopedSlots: { customRender: 'orderNo' }
           },
           {
             slots: { title: 'title_residueQuantity'},
             dataIndex: 'residueQuantity',
             key: 'residueQuantity',
             width: '110px',
             scopedSlots: { customRender: 'residueQuantity' }
           },  */
        {
          // title: '预约总量',
          slots: { title: 'title_total_predictQuantity' },
          dataIndex: 'totalPredictQuantity',
          key: 'totalPredictQuantity',
          width: '150px',
          scopedSlots: { customRender: 'totalPredictQuantity' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          width: '150px',
          scopedSlots: { customRender: 'operation' }
        }

        /*     customRender: (value, row, index) => {
              console.log("index="+index)
              console.log(row)
              const obj = {
                children: value,
                attrs: {},
              };
              obj.attrs.rowSpan = 2;
              obj.attrs.colSpan = 0;
              return obj;
            }, */
        /*      {
               // title: '车牌号',
               slots: { title: 'title_vehicleNo'},
               dataIndex: 'vehicleNo',
               key: 'vehicleNo',
               width: '150px',
               scopedSlots: { customRender: 'vehicleNo' }
             },
             {
               // title: '司机姓名',
               slots: { title: 'title_driverName'},
               dataIndex: 'driverName',
               key: 'driverName',
               width: '210px',
               scopedSlots: { customRender: 'driverName' }
             },
             {
               // title: '手机号',
               slots: { title: 'title_phone'},
               dataIndex: 'phone',
               key: 'phone',
               width: '160px',
               scopedSlots: { customRender: 'phone' }
             },
             {
               // title: '上门日期',
               slots: { title: 'title_appointedDate'},
               dataIndex: 'appointedDate',
               key: 'appointedDate',
               width: '180px',
               scopedSlots: { customRender: 'appointedDate' }
             },
             {
               title: '身份证号',
               dataIndex: 'idcard',
               key: 'idcard',
               width: '150px',
               scopedSlots: { customRender: 'idcard' }
             }, */
        /*      {
               title: '操作',
               key: 'action',
               //width: '13%',
               scopedSlots: { customRender: 'operation' }
             } */
      ],
      data: [],

      // 订单查询结果列表
      selectedRowKeys: [],
      orderColumns: [
        {
          title: '客户/供应商',
          dataIndex: 'businessName',
          key: 'businessName',
          //width: '12%', order_businessName
        },
        {
          title: '物料名称',
          dataIndex: 'materielName',
          key: 'materielName',
          //width: '12%',order_materielName
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          key: 'orderNo',
          //width: '12%',order_orderNo
        },
        {
          title: '剩余量(吨)',
          dataIndex: 'remainNum',
          key: 'remainNum',
          //width: '12%',order_residueQuantity
        },
        /*    {
             title: '操作',
             key: 'orderOperation',
             scopedSlots: { customRender: 'orderOperation' }
             //width: '13%',
           } */
      ],
      orderList: [
        /*  {
           order_orderNo: 'XL001',
           order_residueQuantity: 250.5,
           order_materielId: 28,
           order_materielName: '花岗PC32.5袋装(PC32.5)',
           order_businessName: '城区商混_贵州遵义建安混凝土有限公司'
         },
         {
           order_orderNo: 'XL002',
           order_residueQuantity: 250.5,
           order_materielId: 28,
           order_materielName: '花岗PC32.5袋装(PC32.5)',
           order_businessName: '城区商混_贵州遵义建安混凝土有限公司'
         },
         {
           order_orderNo: 'XL003',
           order_residueQuantity: 105,
           order_materielId: 25,
           order_materielName: '助磨剂(早强型)',
           order_businessName: '城区商混_贵州遵义建安混凝土有限公司'
         }, */
      ],
    }
  },

  created() {


    this.configParam()
    this.checkButtonPrivilege()
    this.selectedBizId = this.bizList[0].id
    this.loadBaseInfoList()
    const roles = store.getters.roles
    this.roleId = this.$store.getters.roles
    // 如果登录的用户不是供应商,目前为管理员或采购员,需要选择供应商
    //if (this.roleId !== this.config.RoleType.SUPPLIER){
    this.loadSupplierSelect()
    //}
    this.loadBusinessList()
    this.loadLogisticsSelect()
    this.yuyuelimit()
    //客户只读属性
    console.log("待约标记" + this.rolelimit)

    new Promise(resolve => {
      const data = vehicleTypeList({}).then(res => {
        return res.data
      })
      resolve(data)
    }).then(res => {
      this.corpVehicleTypeSelect = res
    })

  },

  mounted() {
    $("label[title='车号']").before('<span style="color:red;margin-right:1px;">*</span>')
    $("label[title='司机']").before('<span style="color:red;margin-right:1px;">*</span>')
    $("label[title='手机号']").before('<span style="color:red;margin-right:1px;">*</span>')
    $("label[title='上门日期']").before('<span style="color:red;margin-right:1px;">*</span>')
  },

  methods: {
    moment,
    disabledDate(current) {

      // 设置区间之外的日期不可选
      return  current>moment().add(1, "days") || current<moment().subtract(1, "days")
    },
    configParam() {
      new Promise(resolve => {

        const data = findproperties({ key: '15' }).then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.ylminmoney = res.value
        console.log("最小预约金额:" + this.ylminmoney)
      })
    },
    //分配物流记录按钮权限
    checkButtonPrivilege(record) {

      new Promise(resolve => {
        const data = findPrivileBycode({ code: 'dykh-handler' }).then(res => { return res.data })
        resolve(data)
      }).then(res => {

        if (res == 'dykh-handler') {
          this.rolelimit = true

        } else {
          //查找客户code

          new Promise(resolve => {
            const data = selectCodeByCustomer({}).then(res => { return res.data })
            resolve(data)
          }).then(res => {


            this.customercode = res.code

            new Promise(resolve => {

              const data = selectBusinessByCode({ code: this.customercode }).then(res => { return res.data })
              resolve(data)
            }).then(res => {
              this.code1 = res.code
              this.name = res.name
              this.remainAmount = res.remainAmount
              this.level = res.level
              this.codeId1 = res.id
              this.quailty = null
              this.mprice2 = null
              this.yylimit = true
            })
          })

        }
      })

    },
    moment,
    changeCarType(e) {

      new Promise(resolve => {

        const data = findCarTypeById({ id: e.key }).then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.quailty = null
        this.mprice2 = null
        this.maxweight = res.loadWeight
        this.predictQuantity = null
      })
      this.$forceUpdate(); //强制刷新，解决页面不会重新渲染的问题
    },
    changeSupplier(e) {
      this.orderList = []
      this.data = []
      this.selectedRowKeys = []
    },
    yuyuelimit() {
      this.yylimit = false;
    },
    changeBusiness() {
      this.orderList = []
      this.data = []
      this.selectedRowKeys = []
    },

    changecodes(e) {

      var code = e.target.value
      new Promise(resolve => {
        const data = selectBusinessByCode({ code: code }).then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.name = res.name
        this.remainAmount = res.remainAmount
        this.level = res.level
        this.codeId1 = res.id
        this.quailty = null
        this.mprice2 = null

      })
    },

    changeQuailty(e) {

      var code = e.target.value

      console.log("数量" + code);
      var m = 0;
      var s1 = this.mprice.toString().replace(/\s*/g, '');
      var s2 = code.toString().replace(/\s*/g, '');
      try {
        m += s1.split(".")[1].length;
      } catch (e) { }
      try {
        m += s2.split(".")[1].length;
      } catch (e) { }

      this.mprice2 = Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
      var ylmoney = Number(this.mprice2) + Number(this.ylminmoney);
      if (ylmoney > this.remainAmount) {
        this.quailty = ''
        this.mprice2 = ''
       // showMsg('总金额超出余额')
        this.$message.warning('总金额超出余额', 3)
        return
      }
      if (code > this.lessquailty) {
        this.quailty = ''
        this.mprice2 = ''
       // showMsg('预约量超出剩余量')

        this.$message.warning('预约量超出剩余量', 3)
        return
      }
      if (code > this.maxweight) {
        console.log(code + ":" + this.maxweight)
        console.log(code > parseFloat(this.maxweight))
        this.quailty = ''
        this.mprice2 = ''
        //showMsg('预约量超出该车型荷载量'+maxweight)

        this.$message.warning('预约量超出该车型荷载量'+this.maxweight, 3)
        return
      }



    },
    queryOrder() {
      Bus.$emit('showSpinning', true, "订单查询中...")
      // queryOrder({"order_businessCode": this.corpBusinessId, "order_materielName": this.selectMaterielName === "请选择"?'':this.selectMaterielName})
      queryOrder({ "order_businessCode": this.corpBusinessId, "order_materielCode": this.selectMaterielId === "" ? null : this.selectMaterielId })
        .then(res => {
          if (res.code === '0') {
            this.orderList = res.data
          }
        }).catch(() => {
        }).finally(() => {
          Bus.$emit('showSpinning', false)
        })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
    },

    selectAllChange(selected, selectedRows, changeRows) {
      if (selected) {
        for (let i = 0; i < selectedRows.length; i++) {
          let record = selectedRows[i]
          this.addReservation(record)
        }
      } else {
        /*         for (let i = 0; i < changeRows.length; i++){
                  let record = changeRows[i]
                  this.removeReservation(record.order_orderNo)
                } */
        this.data = []
      }

    },

    selectChange(record, selected, selectedRows) {
      if (selected) {
        this.addReservation(record)
        this.syncTotalQuantity(record.order_materielName)
      } else {
        this.removeReservation(record.order_orderNo)
        this.syncTotalQuantity(record.order_materielName)
      }
    },

    // 这里使用x[field], 而不使用x.field  防止x没有field属性 而报错
    sortBy(field) {
      return (x, y) => {
        // return x[field] - y[field];
        return x[field].localeCompare(y[field], 'zh-CN')
      }
    },

    removeReservation(orderNo) {
      const newData = this.data.filter(item => item.orderNo !== orderNo)
      this.data = newData
    },

    addReservation(record) {
      if (this.selectedBizId === this.config.BusinessTypeId.purchase && !this.corpSupplierId) {
        this.$message.warning('请选择供应商', 3)
        this.selectMater = { key: '', label: '请选择' }
        return;
      }
      if (this.selectedBizId === this.config.BusinessTypeId.sell && !this.corpBusinessId) {
        this.$message.warning('请选择客户', 3)
        this.selectMater = { key: '', label: '请选择' }
        return;
      }

      const length = this.data.length
      if (length > 0 && this.preBizId !== this.selectedBizId) {
        this.$message.warning('只能预约同一种类型的物料', 3)
        return
      }
      this.preBizId = this.selectedBizId

      // 如果是无订单预约
      if (this.hasOrder !== '1') {
        if (!this.selectMaterielName || !this.selectMaterielId) {
          this.$message.warning('请选择物料', 3)
          return;
        }
        let obj = this.data.find((item) => {
          return item.materielName === this.selectMaterielName;
        });
        if (obj && obj.materielName) {
          // this.$message.warning('请选择不同的物料',3)
          return;
        }
        record = { "order_materielName": this.selectMaterielName, "order_materielId": this.selectMaterielId }
      }

      this.data.push({
        key: length === 0 ? '1' : (parseInt(this.data[length - 1].key) + 1).toString(),
        // materielName: this.selectMaterielName,
        materielName: record.order_materielName,
        materielId: record.order_materielId,
        predictQuantity: 0,
        totalPredictQuantity: 0,
        //vehicleNo: '',
        //driverName:'',
        //phone: '',
        //appointedDate: this.getCurDate(),
        //appointedDates:moment(new Date(), 'YYYY-MM-DD'),
        //idcard: '',
        orderNo: record.order_orderNo,
        residueQuantity: record.order_residueQuantity,
      })
      // 有订单预约才需要排序
      if (this.hasOrder === '1') {
        this.data.sort(this.sortBy("materielName"))
      }
      // setTimeout(this.config.excuteSetTitle,1000);
    },

    getCurDate() {
      let date = formatDate(new Date(), 'yyyy-MM-dd')
      return date
    },
    loadSupplierSelect() { // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = getCorpSupplierList({}).then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.supplierSelect = res
        if (this.supplierSelect && this.supplierSelect.length > 0) {
          this.corpSupplierId = this.supplierSelect[0].id
        }
      })
    },

    loadBusinessList() { // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = corpBusinessList({}).then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.businessSelect = res
        if (this.businessSelect && this.businessSelect.length > 0) {
          this.corpBusinessId = this.businessSelect[0].id
        }
      })
    },

    loadLogisticsSelect() {
      new Promise(resolve => {
        const data = corpLogisticsList({}).then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.logisticsSelect = res
        /*  if (this.logisticsSelect && this.logisticsSelect.length > 0){
           this.corpLogisticsId =  this.corpLogisticsId[0].id
         } */
      })
    },
    getHasOrderByValue(value) {
      let obj = this.bizList.find((item) => {
        return item.id === value;
      });
      this.hasOrder = obj.hasOrder

      //if (this.hasOrder !== '1'){
      this.orderList = []
      this.data = []
      this.selectedRowKeys = []
      //}
      this.changeColumns()
    },

    changeColumns() {
      let newColumns = []
      this.allColumns.forEach(obj => {
        if (this.hasOrder !== '1') {
          if (obj.dataIndex !== 'orderNo' && obj.dataIndex !== 'residueQuantity' && obj.dataIndex !== 'totalPredictQuantity') {
            newColumns.push(obj)
          }
        } else {
          if (obj.dataIndex !== 'action') {
            newColumns.push(obj)
          }
        }
      })
      this.columns = newColumns
      //this.columns = this.allColumns
    },

    handleBizChange(value) {
      this.data = []
      this.materList = this.materielData[value]
      this.materList.unshift({ "id": "", "name": "请选择" })
      this.selectMater = { key: '', label: '请选择' }
      this.selectMaterielId = null
      this.selectMaterielName = null
      this.getHasOrderByValue(value)
    },

    loadBaseInfoList() { // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = baseInfoList({}).then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.materielList = res.materielList

        for (var i = 0; i < this.materielList.length; i++) {
          let materie = this.materielList[i]
          if (!(this.materielData[materie.businessTypeId] instanceof Array)) {
            this.materielData[materie.businessTypeId] = []
          }
          this.materielData[materie.businessTypeId].push(materie)
        }
        this.materList = this.materielData[this.selectedBizId]

        this.handleBizChange(this.selectedBizId)
      })
    },

    filterOption(input, option) { // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    remove(key) {
      const newData = this.data.filter(item => item.key !== key)
      this.data = newData
    },

    deCompletionDriverName(completedDriverName) {
      let driverName = completedDriverName.substring(0, completedDriverName.indexOf("("));
      let phone = completedDriverName.substring(completedDriverName.indexOf("(") + 1, completedDriverName.indexOf(")"));
      return { "driverName": driverName, "phone": phone };
    },

    handleChange(value, key, column) {
      const newData = [...this.data]
      const target = newData.filter(item => key === item.key)[0]
      if (target) {
        target[column] = value
        this.data = newData
      }
    },

    changeMateriel(e) {
      this.selectMaterielId = e.key
      this.selectMaterielName = e.label
      this.selectMater = { key: e.key.toString(), label: e.label }

      var materielId = e.key
      var levels = null
      if (this.level === "A") {
        levels = 1
      } else if (this.level === "B") {
        levels = 2
      } else if (this.level === "C") {
        levels = 3
      } else if (this.level === "D") {
        levels = 4
      }
      new Promise(resolve => {
        const data = materielPriceselectBycodelevel({ materielId: materielId, customerLevel: levels }).then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.mprice = res.price
        this.lessquailty = res.remainQuality
        this.materielSpec = res.materielSpec
        this.quailty = null
        this.mprice2 = null
      })
      // this.newMember()
    },

    // 四舍五入保留两位小数
    keepTwoDecimal(num) {
      var result = parseFloat(num);
      if (isNaN(result)) {
        return '';
      }
      result = Math.round(num * 100) / 100;
      return result;
    },

    syncTotalQuantity(materielName) {
      let indexArr = []
      let sumPredictQuantity = this.data.reduce(function (total, currentValue, currentIndex, arr) {
        if (materielName === currentValue.materielName) {
          total = total + (currentValue.predictQuantity || 0)
          // total = Number(total) + Number(currentValue.predictQuantity || 0)
          // total = this.keepTwoDecimal(total)
          indexArr.push(currentIndex)
          return total
        } else {
          return total
        }
      }, 0);

      let data = this.data
      for (let i = 0; i < indexArr.length; i++) {
        let index = indexArr[i]
        data[index].totalPredictQuantity = sumPredictQuantity
      }
      this.data = data
    },

    changeNumber(value, record) {
      let key = record.key
      value = parseFloat(value);
      if (!value || isNaN(value)) {
        value = 0;
        // return;
      }
      const newData = [...this.data]
      const target = newData.filter(item => key === item.key)[0]
      if (target) {
        target['predictQuantity'] = value
        this.data = newData
      }
      this.syncTotalQuantity(record.materielName)
    },

    changeVehicleNo(value, isUpperCase) {
      // 限制只能输入7位
      if (value.length > this.config.vehicleNoLength) {
        this.vehicleNo = value.substring(0, this.config.vehicleNoLength)
      }
      // 转换成大写
      if (isUpperCase === true && value.length >= 7) {
        this.vehicleNo = value.toUpperCase();
      }
      //查询车子
      if (this.vehicleNo != '' && this.vehicleNo.length > 3) {
        new Promise(resolve => {
          const data = findscanquery({ vehicleNo: this.vehicleNo }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.vehicleNoList = res

        })

       // if(this.vehicleNo.length ==7) {
          new Promise(resolve => {
            const data = findcarnoinfo({vehicleNo: this.vehicleNo}).then(res => {
              return res.data
            })
            resolve(data)
          }).then(res => {
            if (res == null) {
            } else {
              this.driverName = res.dname
              this.phone = res.phone
              this.idcard = res.idcard

              this.vehicleTypeId.key = res.vehicleTypId
              this.vehicleTypeId.label = res.vehicleTypeName
              this.maxweight = res.loads
              this.maxAppoint = res.maxAppoint

              /*this.vehicleTypeId = res.vehicleTypId
              this.maxweight = res.loads*/
            }
          })
       // }

        /*new Promise(resolve => {
          const data = findcartypeinfo({ vehicleNo: this.vehicleNo }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          if (res == null) {

          } else {
            this.vehicleTypeId.key = res.vehicleType
            this.vehicleTypeId.label = res.vname

            this.maxweight = res.loadWeight
          }
        })*/
      }



    },





    check_car_name(car_name) {
      var re = /^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z_0-9]{5}$/;
      if (car_name.search(re) == -1) {
        return false;
      } else {
        return true;
      }
    },
    validate() {




      var m = 0;
      var s1 = this.mprice.toString();
      var s2 = this.quailty.toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) { }
      try {
        m += s2.split(".")[1].length;
      } catch (e) { }

      var kk = Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
      // console.log("算出总金额:"+kk+",输入框金额:"+this.mprice2)
      if (kk !== this.mprice2) {
        this.$message.warning('总金额不正确', 3)
        return false
      }

      if (this.selectedBizId === this.config.BusinessTypeId.sell && !this.corpBusinessId) {
        this.$message.warning('请选择客户', 3)
        return;
      }
      if (!this.vehicleTypeId || !this.maxweight) {
        this.$message.warning('请选择车型', 3)
        return false
      }
      if (!this.vehicleNo || !this.driverName || !this.phone || !this.appointedDate) {
        this.$message.warning('请完善预约信息', 3)
        return false
      }
      if (this.quailty <= 0) {
        this.$message.warning('预约量不能为0', 3)
        return false
      }
      if (!this.config.Regex.telephone.test(this.phone)) {
        this.$message.warning('手机号格式错误', 3)
        return false
      }
      /*if(this.idcard){
             if (!this.config.Regex.idCardNum.test(this.idcard)) {
             this.$message.warning('身份证格式错误',3)
             return false
             }
          }*/

      /* if (!this.config.Regex.idCardNum.test(item.idcard)) {
         this.$message.warning('身份证格式错误',3)
         return false
       }*/
      var today = new Date();
      var targetDate = new Date(this.appointedDate + " 23:59:59".replace("-", "/").replace("-", "/"));
      if (targetDate < today) {
        this.$message.warning('上门日期不能小于当天', 3)
        return false;
      }
      // 设置下供应商和业务类型ID
      if (this.selectedBizId === this.config.BusinessTypeId.sell) {
        this.corpBusinessId = this.corpBusinessId
        this.corpSupplierId = null
      } else {
        this.corpSupplierId = this.corpSupplierId
        this.corpBusinessId = null
      }
      for (let i = 0; i < this.data.length; i++) {
        let item = this.data[i]
        if (!item.materielName || !item.predictQuantity) {
          this.$message.warning('请完善预约信息', 3)
          return false
        }
        /*         if ( parseFloat(item.predictQuantity) <= 0) {
                  this.$message.warning('预约数量不能小于等于0',3)
                  return false
                } */
        /*             if (item.vehicleNo.length != 7){
                      this.$message.warning('车牌号必须为七位数',3)
                      return false;
                    } */

        /*        if (this.check_car_name(value) == false) {
                 this.$message.warning('请输入正确的车牌号',3)
                 return false;
               } */
      }
      return true
    },

    // 最终全页面提交
    doSubmit() {
      if (!this.validate()) {
        return
      }
      if(this.quailty && this.maxAppoint){
        if(this.quailty > this.maxAppoint){
          this.$message.warning('预约量超过该车设置的最大预约量:'+'该车最大预约量'+this.maxAppoint)
          return
        }
      }
      const _this = this
      _this.loading = true
      console.log("物料名称id:" + this.selectMaterielId);
      let obj = { 'maxweight': this.maxweight, 'vehicleTypeId': this.vehicleTypeId.key, 'mprice': this.mprice, 'mprice2': this.mprice2, 'predictQuantity': this.quailty, 'materielMultiParam': this.selectMaterielId, 'businessTypeId': this.selectedBizId, 'corpSupplierId': this.corpSupplierId, 'corpBusinessId': this.codeId1, 'corpLogisticsId': this.corpLogisticsId, 'vehicleNo': this.vehicleNo, 'driverName': this.driverName, 'phone': this.phone, 'idcard': this.idcard, 'appointedDate': this.appointedDate, 'hasOrder': this.hasOrder }
      Bus.$emit('showSpinning', true, "提交中...")
      reservationAddMulti(obj)
        .then(res => {
          if (res.code === '0') {
            this.data = []
            if (!this.continuity) {
              this.$router.push({ name: 'reservation' })
            } else {
              // 清空数据
              this.data = []
              this.orderList = []

              this.vehicleNo = ''
              this.driverName = ''
              this.phone = ''
              this.idcard = ''
              this.appointedDate = this.defaultDate
            }
          }
        }).catch(() => {
        }).finally(() => {
          _this.loading = false
          Bus.$emit('showSpinning', false)
        })
    },
    scrollToField(fieldKey) {
      const labelNode = document.querySelector(`label[for="${fieldKey}"]`)
      if (labelNode) {
        labelNode.scrollIntoView(true)
      }
    }
  }
}
  </script>

  <style lang="less" scoped>
.card {
  margin-bottom: 1px;
}
/*.ant-form-item-label label {
  margin: 5px;
}*/
</style>

  <style scoped>
/deep/ .ant-table-row {
  height: 45px;
}
</style>